<template>
    <splashscreen>
        <h3 class="text-4xl mt-0 mb-3">
            {{ $t('maintenanceMode.title') }}
        </h3>
        <p class="text-lg mt-0 mb-6">
            {{ $t('maintenanceMode.subtitle1') }}<br />
            <i18n-t keypath="maintenanceMode.subtitle2" tag="span">
                <a target="_blank" href="http://status.activix.ca">
                    {{ $t('maintenanceMode.statusPage') }}
                </a>
            </i18n-t>
        </p>
        <activix-button type="primary" :loading="loading" @click="reload">
            {{ $t('maintenanceMode.reload') }}
        </activix-button>
    </splashscreen>
</template>

<script>
    import Splashscreen from '../layouts/Splashscreen.vue';

    export default {
        components: {
            Splashscreen,
        },

        data() {
            return {
                loading: false,
            };
        },

        methods: {
            reload() {
                this.loading = true;
                window.location.reload();
            },
        },
    };
</script>
